import React, { useEffect, useState, useRef } from 'react'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import ListItemText from '@mui/material/ListItemText'
import { color } from '../../api/ColorsSector'
import MenuItem from '@mui/material/MenuItem'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import AddCircleOutlineSharpIcon from '@mui/icons-material/AddCircleOutlineSharp'
import DoneOutlineSharpIcon from '@mui/icons-material/DoneOutlineSharp'
import Box from '@mui/material/Box'
import DialogContent from '@mui/material/DialogContent'
import Avatar from '@mui/material/Avatar'
import Stack from '@mui/material/Stack'
import Grid from '@mui/material/Grid2'
import { useSnackbar } from '../../alert/SnackbarProvider'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { formatDateToDDMMYYYY } from '../../api/formatDate'
import '../../styles/main.css'
import {
  updateData,
  addData,
  deleteData,
  getData,
  upsertDataTournaments,
  ids,
} from '../../api/indexedDBHandler'
import { useParams } from 'react-router-dom'
import Backdrop from '@mui/material/Backdrop'
import DeleteIcon from '@mui/icons-material/Delete'
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import Button from '@mui/material/Button'

import IconButton from '@mui/material/IconButton'
import SmartToyIcon from '@mui/icons-material/SmartToy'
import Modal from '@mui/material/Modal'
import EditSharpIcon from '@mui/icons-material/EditSharp'
import CircularProgress from '@mui/material/CircularProgress'
import StarIcon from '@mui/icons-material/Star'
import ModalAddTeam from '../Modal/ModalAddTeam'
import { ErrorTwoTone } from '@mui/icons-material'

const TeamDrawCardComQ = ({
  tournament,
  teamDataTemp,
  athleteDataTemp,
  typeDraw,
  response,
  typeCard,
  ids,
}) => {
  const { id } = useParams()
  const [openBackdrop, setOpenBackdrop] = useState(false)
  const [teamData, setteamData] = useState(null)
  const [athleteData, setathleteData] = useState(null)
  const [queue, setQueue] = useState('')
  const [comand_name, set_comand_name] = useState(null)
  const [selectedZonas, setSelectedZonas] = useState({})
  const [selectedSectors, setSelectedSectors] = useState({})
  const [error, setError] = useState('')
  const inputRefZona = useRef({})
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }
  const dob_sport_categori = (sports_category, dob) => {
    var arr = []
    if (sports_category) arr.push(sports_category)
    if (dob != '0000-00-00') arr.push(formatDateToDDMMYYYY(dob) + ' г.р.')
    return arr.join(', ')
  }
  const f_setQueue = (e) => {
    setQueue(e)
  }
  const inputRef = useRef(null) // Создаем ссылку

  const dellhandleClick = (e) => {
    response(
      null,
      {
        teamId: e,
        zona: null,
        sector: null,
      },
      'addSectorQ'
    )
    //response(null, ids, 'delQueue')
  }
  const dellhandleClickSector = () => {
    response(null, ids, 'delSector')
  }

  const handleClickSector = () => {
    const value = inputRef.current.value
    if (value != '') response(value, ids)
  }

  const handleClickQueue = () => {
    const value = inputRef.current.value.replace(/\D/g, '')
    if (value != '' && value > 0) response(value, ids, 'Queue')
  }

  const name = (team) => {
    if (tournament.competition_type == 'Рейтинговое соревнование')
      return team?.team_name_ru
    return team?.preferred_name == 'en'
      ? team?.team_name_en
        ? team?.team_name_en
        : team?.team_name_ru
      : team?.team_name_ru
  }
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }))
  useEffect(() => {
    if (athleteData) {
      console.log('athleteData', athleteData)
      setteamData(athleteData)
      if (athleteData.length > 1 && !comand_name) {
        if (athleteData[0]?.team.comand_name)
          set_comand_name(athleteData[0].team.comand_name)
        else {
          const detTeamName = async () => {
            let tn = null
            const resultsC = await getData('communication', 'id', id)
            if (resultsC.length > 0) {
              const { key, value } = resultsC[0]
              console.log('athleteData value', value)
              if (athleteData.length >= 2) {
                const ids = athleteData.slice(1).map((item) => item.team?.id)
                console.log('ids value', ids)
                console.log('ids ids[0]', ids[0])
                if (ids.every((id) => value[id])) {
                  tn = value[ids[0]]
                }
              }
            }
            if (!tn) {
              const str1 = name(athleteData[0].team)
              const str2 = athleteData[1]?.team.id
                ? ' + ' + name(athleteData[1].team)
                : ''
              const str3 = athleteData[2]?.team.id
                ? ' + ' + name(athleteData[2].team)
                : ''
              tn = str1 + str2 + str3
            }
            set_comand_name(tn)
          }
          detTeamName()
        }
      } else {
        // set_comand_name(name(athleteData[0]?.team))
      }
    }
  }, [athleteData])

  useEffect(() => {
    setathleteData(athleteDataTemp)
  }, [athleteDataTemp])

  const notCommunication = () => {
    return (
      <Grid size={{ xs: 12, md: 12 }}>
        <Item
          className="regateam"
          style={{
            padding: '18px',
          }}
        >
          <Stack direction="row" spacing={2} style={{ textAlign: 'left' }}>
            <div>
              <Typography
                variant="h6"
                gutterBottom
                style={{ marginBottom: '0px', lineHeight: '1.2' }}
                className="color-text-black"
              >
                {name(athleteData.team)}
              </Typography>
              <Typography variant="caption" gutterBottom>
                {athleteData.team.name}
              </Typography>
            </div>
          </Stack>
          <Stack direction="row" spacing={2} style={{ textAlign: 'left' }}>
            <div>
              {athleteData.athlete.map((athlete, index) => (
                <Stack
                  key={athlete.id}
                  direction="row"
                  spacing={2}
                  style={{ textAlign: 'left', paddingTop: '20px' }}
                >
                  <div>
                    <Typography
                      variant="body1"
                      gutterBottom
                      style={{ marginBottom: '0px' }}
                      className="color-text-black"
                    >
                      {athlete.fio}{' '}
                      {athlete.identification == 'идентифицирован' ? (
                        <StarIcon
                          fontSize="small"
                          style={{ fill: '#2a52be' }}
                        />
                      ) : (
                        <></>
                      )}
                    </Typography>
                    <Typography
                      variant="caption"
                      gutterBottom
                      sx={{ display: 'block' }}
                    >
                      {dob_sport_categori(athlete.sports_category, athlete.dob)}
                    </Typography>
                  </div>
                </Stack>
              ))}
            </div>
            <Box sx={{ flexGrow: 1 }} />
          </Stack>
          {returnsecor(athleteData.team, athleteData)}
          {returnqueue(athleteData.team)}
        </Item>
      </Grid>
    )
  }
  const returnqueue = (team) => {
    if (!team.queue)
      return (
        <Stack
          direction="row"
          spacing={2}
          style={{ textAlign: 'left', paddingTop: '10px' }}
        >
          <div> НОМЕР ОЧЕРЕДИ: </div>
          <div>
            <TextField
              inputRef={inputRef}
              type="tel"
              sx={{ marginBottom: 1, marginTop: 1 }}
            />
            <div style={{ textAlign: 'end' }}>
              <Button
                onClick={handleClickQueue}
                variant="contained"
                size="small"
              >
                Сохранить очередь
              </Button>
            </div>
          </div>
        </Stack>
      )
    else
      return (
        <Stack
          direction="row"
          spacing={2}
          style={{ textAlign: 'left', paddingTop: '10px' }}
        >
          <div> НОМЕР ОЧЕРЕДИ: {team.queue}</div>
        </Stack>
      )
  }

  const nullErrorHandler = () => {
    setError('')
  }
  const handleZonaChange = (teamId, event) => {
    setError('')

    const newZona = event.target.value

    setSelectedZonas((prev) => ({
      ...prev,
      [teamId]: newZona,
    }))

    if (typeof athleteData !== 'object') {
      const hasDuplicate = athleteData.some(
        (t) => t.team.zona === newZona && t.team.id !== teamId
      )

      setError(hasDuplicate ? 'Эта зона уже занята другой командой' : '')
    }
  }

  const comand_name_change = (event) => {
    console.log('comand_name_change', event.target.value)
    // Здесь обычно также обновляется состояние:
    // setComand_name(event.target.value);
  }
  const handleSave = (teamId) => {
    const zona = selectedZonas[teamId]
    const sector = inputRefZona.current[teamId]?.value

    if (!zona) {
      setError('Выберите зону')
      return
    }
    if (!sector || isNaN(sector) || sector <= 0) {
      setError('Введите корректный сектор')
      return
    }
    setSelectedSectors((prev) => ({ ...prev, [teamId]: sector }))
    response(
      null,
      {
        teamId: teamId,
        zona: zona,
        sector: sector,
      },
      'addSectorQ'
    )
    // Вызываем функцию сохранения для конкретной команды
    // handleClickQueue()
  }
  const returnsecor = (team, allteam) => {
    if (team.queue && !team.sector && !team.zona) {
      return (
        <Stack spacing={2} style={{ textAlign: 'left', paddingTop: '10px' }}>
          <div>
            <div>ЗОНА:</div>
            <Select
              id={team.id}
              value={selectedZonas[team.id] || ''}
              onChange={(e) => handleZonaChange(team.id, e)}
              displayEmpty
              fullWidth
              sx={{ minWidth: 120 }}
            >
              <MenuItem value="" disabled>
                Выберите зону
              </MenuItem>

              <MenuItem value="А">
                <Box display="flex" alignItems="center">
                  <FiberManualRecordIcon
                    sx={{ color: color('А'), fontSize: 16, mr: 1 }}
                  />
                  <ListItemText primary="Зона А" secondary="красная зона" />
                </Box>
              </MenuItem>

              <MenuItem value="Б">
                <Box display="flex" alignItems="center">
                  <FiberManualRecordIcon
                    sx={{ color: color('Б'), fontSize: 16, mr: 1 }}
                  />
                  <ListItemText primary="Зона Б" secondary="синяя зона" />
                </Box>
              </MenuItem>

              <MenuItem value="В">
                <Box display="flex" alignItems="center">
                  <FiberManualRecordIcon
                    sx={{ color: color('В'), fontSize: 16, mr: 1 }}
                  />
                  <ListItemText primary="Зона В" secondary="желтая зона" />
                </Box>
              </MenuItem>
            </Select>
          </div>
          <div>
            <div>СЕКТОР:</div>
            <div>
              <TextField
                fullWidth
                onChange={nullErrorHandler}
                inputRef={(el) => (inputRefZona.current[team.id] = el)}
                type="text"
                sx={{ marginBottom: 1, marginTop: 1 }}
              />
              {error && (
                <Typography color="error" variant="caption">
                  {error}
                </Typography>
              )}
            </div>
            <div style={{ textAlign: 'end' }}>
              <Button
                onClick={() => handleSave(team.id)}
                variant="contained"
                size="small"
                disabled={!!error}
              >
                Сохранить
              </Button>
            </div>
          </div>
        </Stack>
      )
    } else if (team.queue && team.sector && team.zona) {
      return (
        <div style={{ textAlign: 'left', paddingTop: '10px' }}>
          <div>
            <b> ЗОНА: {team.zona}</b>
            <IconButton
              aria-label="delete"
              size="small"
              onClick={() => dellhandleClick(team.id)}
            >
              <DeleteIcon fontSize="inherit" style={{ fill: 'red' }} />
            </IconButton>
          </div>
          <div>
            <b>НОМЕР СЕКТОРА: {team.sector}</b>
            <IconButton
              aria-label="delete"
              size="small"
              onClick={() => dellhandleClick(team.id)}
            >
              <DeleteIcon fontSize="inherit" style={{ fill: 'red' }} />
            </IconButton>
          </div>
        </div>
      )
    }
  }
  const сommunication = () => {
    if (athleteData)
      return (
        <Item
          key={athleteData.id}
          className="regateam"
          style={{
            padding: '18px',
            width: '100%',
          }}
        >
          <Grid container spacing={2} style={{ paddingTop: '10px' }}>
            <Grid item size={{ xs: 12, md: 12 }}>
              <TextField
                id="standard-basic"
                label="Название команды  "
                variant="standard"
                fullWidth
                value={comand_name}
                onChange={(event) => comand_name_change(event)}
              />
            </Grid>

            {athleteData.map((team, index) => (
              <Grid item size={{ xs: 12, md: 4 }} key={`athlete-${index}`}>
                <Stack
                  direction="row"
                  spacing={2}
                  style={{ textAlign: 'left' }}
                >
                  <div>
                    <div>
                      <Typography
                        variant="h6"
                        gutterBottom
                        style={{ marginBottom: '0px', lineHeight: '1.2' }}
                        className="color-text-black"
                      >
                        {'пара: ' + name(team.team)}{' '}
                      </Typography>
                    </div>
                    <Typography variant="caption" gutterBottom>
                      {team.team.name}
                    </Typography>
                  </div>
                </Stack>
                <Stack
                  direction="row"
                  spacing={2}
                  style={{ textAlign: 'left' }}
                >
                  <div>
                    {team.athlete.map((athlete, index) => (
                      <Stack
                        key={athlete.id}
                        direction="row"
                        spacing={2}
                        style={{ textAlign: 'left', paddingTop: '20px' }}
                      >
                        <div>
                          <Typography
                            variant="body1"
                            gutterBottom
                            style={{ marginBottom: '0px' }}
                            className="color-text-black"
                          >
                            {athlete.fio}{' '}
                            {athlete.identification == 'идентифицирован' ? (
                              <StarIcon
                                fontSize="small"
                                style={{ fill: '#2a52be' }}
                              />
                            ) : (
                              <></>
                            )}
                          </Typography>
                          <Typography
                            variant="caption"
                            gutterBottom
                            sx={{ display: 'block' }}
                          >
                            {dob_sport_categori(
                              athlete.sports_category,
                              athlete.dob
                            )}
                          </Typography>
                        </div>
                      </Stack>
                    ))}
                  </div>
                </Stack>
                {returnsecor(team.team, athleteData)}
              </Grid>
            ))}
          </Grid>
          {returnqueue(athleteData[0]?.team)}
        </Item>
      )
  }
  if (teamData)
    return (
      <>
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={openBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {typeCard === 'single' && notCommunication()}
        {typeCard === 'group' && сommunication()}
      </>
    )
}

export default TeamDrawCardComQ
